import detail1 from './static/detail-1.png'
// import detail2 from './static/detail-2.jpg'
// import detail3 from './static/detail-3.jpg'
import detail4 from './static/favicon.png'
import gd1 from './static/gd-1-20191011-min.png'
import xq from './static/xq-20191011-min.png'
import mj from './static/mj-20191011.jpg'

import cooperative1 from './static/ad/1/1.png'
import cooperative2 from './static/ad/1/2.png'
import cooperative3 from './static/ad/1/3.png'
import cooperative4 from './static/ad/1/4.png'
import cooperative5 from './static/ad/1/5.png'
import cooperative6 from './static/ad/1/6.png'
import cooperative7 from './static/ad/1/7.png'
import cooperative8 from './static/ad/1/8.png'
import cooperative9 from './static/ad/1/9.png'

import ad1 from './static/ad/2/1.png'
import ad2 from './static/ad/2/2.png'
import ad3 from './static/ad/2/3.png'
import ad4 from './static/ad/2/4.png'
import ad5 from './static/ad/2/5.png'
import ad6 from './static/ad/2/6.png'
import ad7 from './static/ad/2/7.png'
import ad8 from './static/ad/2/8.png'
import ad9 from './static/ad/2/9.png'
import ad10 from './static/ad/2/10.png'
import ad11 from './static/ad/2/11.png'
import ad12 from './static/ad/2/12.png'
import ad13 from './static/ad/2/13.png'
import ad14 from './static/ad/2/14.png'
import ad15 from './static/ad/2/15.png'
import ad16 from './static/ad/2/16.png'
import ad17 from './static/ad/2/17.png'
import ad18 from './static/ad/2/18.png'
import ad19 from './static/ad/2/19.png'
import ad20 from './static/ad/2/20.png'
import ad21 from './static/ad/2/21.png'
import ad22 from './static/ad/2/22.png'
import ad23 from './static/ad/2/23.png'
import ad24 from './static/ad/2/24.png'
import ad25 from './static/ad/2/25.png'
import ad26 from './static/ad/2/26.png'
import ad27 from './static/ad/2/27.png'
import ad28 from './static/ad/2/28.png'
import ad29 from './static/ad/2/29.png'
import ad30 from './static/ad/2/30.png'
import ad31 from './static/ad/2/31.png'
import ad32 from './static/ad/2/32.png'
import ad33 from './static/ad/2/33.png'
import ad34 from './static/ad/2/34.png'
import ad35 from './static/ad/2/35.png'
import ad36 from './static/ad/2/36.png'
import ad37 from './static/ad/2/37.png'
import ad38 from './static/ad/2/38.png'
import ad39 from './static/ad/2/39.png'
import ad40 from './static/ad/2/40.png'
import ad41 from './static/ad/2/41.png'
import ad42 from './static/ad/2/42.png'
import ad43 from './static/ad/2/43.png'
import ad44 from './static/ad/2/44.png'
import ad45 from './static/ad/2/45.png'
import ad46 from './static/ad/2/46.png'



// 属性介绍
// 标题： title
// 创建时间： createTime
// 内容： content

const gameList = [
  {
    'title': '梦幻炫舞',
    'describe': '全民音舞社交手游',
    'domain': 'http://x5.gg.com',
    'icon': detail1,
    'content': '<body class="view" spellcheck="false" style="cursor: text;"><p><strong><span style="font-size:24px;font-family:" 微软雅黑","sans-serif""=""><img src="https://www.gg.com/static/gw/img/common/TID.jpg" title="1570690517252725.jpg" _src="https://www.gg.com/static/gw/img/common/TID.jpg" alt="QQ图片20191010145357.jpg"></span></strong></p><p><strong><span style="font-size:20px;font-family:" 微软雅黑","sans-serif";color:red;background:="" yellow;background:yellow"="">游戏介绍：</span></strong></p><p style="text-indent:28px"><span style="font-family:" 微软雅黑","sans-serif""="">《梦幻炫舞》由上海域起网络科技有限公司倾力自主开发，拥有高精模型的3D人物及行云流水般的原版镜头舞步，是一款集舞蹈、换装、社交、竞技、养成等多项娱乐玩法于一体的多人在线音乐舞蹈游戏。</span></p><p style="text-indent:28px"><span style="font-family:" 微软雅黑","sans-serif""="">豪华声优阵容，原创故事情节，开启梦舞大陆奇幻之旅，与NPC趣味互动，和梦舞国度产生深深的羁绊。百变服饰风格，实现个性搭配，在人群中尽情闪耀。多样玩法模式，海量音乐舞蹈，畅舞梦舞大陆，在律动的节奏中玩转指尖世界。多项竞技玩法，hold住舞台全场，show出自己的超凡实力。</span></p><p style="text-indent:28px"><span style="font-family:" 微软雅黑","sans-serif""="">强大的休闲社交体系，多项社交模块，万千玩家都是梦舞国度的伙伴。广阔的休闲社区，自由开放的舞蹈大厅，展示真我的社交中心，总能找寻到心仪的伙伴。好友、家族、舞团，都会让梦舞国度成为温暖的港湾。</span></p><p style="text-indent:28px"><span style="font-family:" 微软雅黑","sans-serif""="">快去开启《梦幻炫舞》之旅，勇敢的show出自己，站在世界频道大声呐喊，寻找那一份久违的缘分邂逅吧！</span></p></body>',
    'androidLink': 'http://gg.cn/res/guanwang_sign_align.apk',
    'iosLink': 'https://itunes.apple.com/cn/app/id1331927655?mt=8'
  },
  {
    'title': '哥哥斗地主',
    'describe': '海量棋牌玩法，激情游戏体验',
    'domain': '',
    'icon': detail4,
    'content': '<body class="view" spellcheck="false" style="cursor: text;"><p><strong><span style="font-size:24px;font-family:"微软雅黑","sans-serif""><img src="https://www.gg.com/static/images/20191216/ggyx.jpg" title="1568622797746303.jpg" _src="httsp:/www./gg.com/static/images/20191216/ggyx.jpg" alt="排位赛气氛.jpg"></span></strong></p><p><strong><span style="font-size:20px;font-family:"微软雅黑","sans-serif";color:red;background: yellow;background:yellow">游戏介绍：</span></strong></p><p style="text-indent:28px"><span style="font-family:"微软雅黑","sans-serif""></span></p><div>&nbsp;《哥哥斗地主》是一款棋牌玩法游戏，涵盖全国主流棋牌玩法，其中包括国民棋牌玩法斗地主等；自上线以来深受广大玩家的喜爱，现各大应用商店均可下载，好评如潮，欢迎下载体验！&nbsp;</div></body>',
    'androidLink': 'https://www.gg.com/static/apk/ggyxdtwx.apk',
    'iosLink': 'https://itunes.apple.com/cn/app/id1423930056?mt=8'
  },
  {
    'title': '我是掼蛋王',
    'describe': '南京电视台《我是掼蛋王》同名手游',
    'domain': '',
    'icon': gd1,
    'content': '<body class="view" spellcheck="false" style="cursor: text;"><p><img src="https://www.gg.com/static/images/20191216/gd.jpg" title="1570614678174782.jpg" _src="https://www.gg.com/static/images/20191216/gd.jpg" alt="掼蛋--宣传-完成.jpg"></p><section class="_editor"><p><br></p></section><p style="text-indent: 14px; text-align: center;"><strong><span style="font-family:宋体"><span style="font-family: 宋体; font-size: 22px;">游戏介绍</span></span></strong><span style="font-family:宋体"><span style="font-family: 宋体; font-size: 22px;"></span><br></span></p><p style="text-indent:14px"><span style="font-family:宋体">“饭前不掼蛋，等于没吃饭”掼蛋是一种在江苏和安徽地区广为流传的扑克游戏，起源于江苏省</span><a href="https://baike.baidu.com/item/%E6%B7%AE%E5%AE%89%E5%B8%82/2613880" target="https://baike.baidu.com/item/_blank" _href="https://baike.baidu.com/item/%E6%B7%AE%E5%AE%89%E5%B8%82/2613880"><span style="font-family: 宋体;color:windowtext;text-underline:none">淮安市</span></a><span style="font-family:宋体">，是由地方的扑克牌局</span> <span style="font-family:宋体">“跑得快”和“八十分”发展演化而来。</span></p><p style="text-indent:14px"><span style="font-family:宋体">《我是掼蛋王》是上海域起网络科技有限公司研发，联合南京电视台联合推出的</span><a href="https://baike.baidu.com/item/%E6%8E%BC%E8%9B%8B/10312030" target="https://baike.baidu.com/item/_blank" _href="https://baike.baidu.com/item/%E6%8E%BC%E8%9B%8B/10312030"><span style="font-family: 宋体;color:windowtext;text-underline:none">掼蛋</span></a><span style="font-family:宋体">游戏网上竞技平台</span>&nbsp;<span style="font-family:宋体">，专为全国掼蛋爱好者打造，采用了垂直理牌界面，并加入了同花顺筛选功能，增强了游戏性。同时也是</span><a href="https://baike.baidu.com/item/%E5%8D%97%E4%BA%AC%E7%94%B5%E8%A7%86%E5%8F%B0/4695984" target="https://baike.baidu.com/item/_blank" _href="https://baike.baidu.com/item/%E5%8D%97%E4%BA%AC%E7%94%B5%E8%A7%86%E5%8F%B0/4695984"><span style="font-family: 宋体;color:windowtext;text-underline:none">南京电视台</span></a><span style="font-family:宋体">生活娱乐频道《我是掼蛋王》节目同名手游，及御用网上选拔平台。</span></p><p></p></body>',
    'androidLink': 'http://www.gg.com/static/apk/wsgdw.apk',
    'iosLink': 'https://apps.apple.com/cn/app/id1441414873'
  },
  {
    'title': '哥哥中国象棋',
    'describe': '经典象棋游戏，好友在线博弈',
    'domain': '',
    'icon': xq,
    'content': '<body class="view" spellcheck="false" style="cursor: text;"><section class="_editor"><p><img src="https://www.gg.com/static/images/20191216/xq.jpg" title="1570615095994202.jpg" alt="掼蛋--宣传-完成-1.jpg" _src="https://www.gg.com/static/images/20191216/xq.jpg"></p><p style="text-indent: 28px; text-align: center;"><strong><span style="font-family:宋体"><span style="font-family: 宋体; font-size: 22px;">游戏介绍</span></span></strong><span style="font-family:宋体"><span style="font-family: 宋体; font-size: 22px;"></span><br></span></p><p style="text-indent:28px"><span style="font-family:宋体">中国象棋是起源于中国的一种棋类游戏，属于二人</span><a href="https://baike.baidu.com/item/%E5%AF%B9%E6%8A%97%E6%80%A7%E6%B8%B8%E6%88%8F/1959177" target="https://baike.baidu.com/item/%E4%B8%AD%E5%9B%BD%E8%B1%A1%E6%A3%8B/_blank" _href="https://baike.baidu.com/item/%E5%AF%B9%E6%8A%97%E6%80%A7%E6%B8%B8%E6%88%8F/1959177"><span style="font-family:宋体;color:windowtext;text-underline:none">对抗性游戏</span></a><span style="font-family:宋体">的一种，在中国有着</span><a href="https://baike.baidu.com/item/%E6%82%A0%E4%B9%85/9310358" target="https://baike.baidu.com/item/%E4%B8%AD%E5%9B%BD%E8%B1%A1%E6%A3%8B/_blank" _href="https://baike.baidu.com/item/%E6%82%A0%E4%B9%85/9310358"><span style="font-family:宋体;color:windowtext;text-underline:none">悠久</span></a><span style="font-family:宋体">的历史。由于用具简单，趣味性强，成为流行极为广泛的棋艺活动。</span></p><p style="text-indent:28px"><span style="font-family:宋体">《哥哥中国象棋》是上海域起网络科技有限公司研发和运营的一款经典象棋游戏，先后在微信小游戏、头条小游戏、</span>QQ<span style="font-family:宋体">小游戏上线，并获得广大玩家的好评。在经典象棋玩法基础上，还加入揭棋、创关、残局、好友对战等创新玩法，给广大象棋爱好者带来多样化的游戏！</span></p><p style="text-align: center;width:30%;margin: 0 auto;"><img src="https://www.gg.com/static/images/20191216/qrcode.png" title="1570708008948978.jpg" _src="https://www.gg.com/static/images/20191216/qrcode.png" alt="哥哥中国象棋.jpg"></p></section></body>',
    'androidLink': '',
    'iosLink': ''
  },
  {
    'title': '哥哥四川麻将',
    'describe': '还原全国各地麻将玩法，秒开局不用等',
    'domain': '',
    'icon': mj,
    'content': '<body class="view" contenteditable="true" spellcheck="false" style="cursor: text;"><section class="_editor"><p style="text-align: center;"></p></section><section class="_editor"><p><img src="https://www.gg.com/static/images/20191216/mj.jpg" title="1570857678979594.jpg" _src="https://www.gg.com/static/images/20191216/mj.jpg" alt="1280-720m.jpg"></p><p style="text-align: center;"><strong><span style="font-size: 22px;">游戏介绍</span></strong><br></p><p style="text-indent:28px"><span style="font-family:宋体">中国有句俗话：“十亿人民九亿麻，还有一亿在观察”，麻将已成为一种老少皆宜的棋牌游戏，而随着地区差异，麻将的玩法也各有不同，</span><span style=";font-family:"Arial","sans-serif";color:#333333;background:white">2017</span><span style=";font-family:宋体;color:#333333;background:white">年</span><span style=";font-family:"Arial","sans-serif";color:#333333;background:white">4</span><span style=";font-family:宋体;color:#333333;background:white">月，国际智力运动联盟宣布，麻将正式成为世界智力运动项目，麻将玩法逐渐风靡全球。</span></p><p style="text-indent:28px"><span style="font-family:宋体"></span></p></section></body>',
    'androidLink': 'http://www.gg.com/static/apk/ggzjmj.apk',
    'iosLink': ''
  }
]

const JDList = {
  'developer': [
    {
      'title': '游戏研发工程师',
      'responsibilities': [
        '1. 负责游戏研发，实现各种功能并进行相关的测试和优化；',
        '2. 参与并负责游戏产品的代码维护工作。'
      ],
      'requirements': [
        '1. 本科及以上学历，计算机及相关专业；',
        '2. 热爱编程，具备较强的编程能力和良好的编码风格；',
        '3. 具备良好的分析解决问题能力, 责任心强, 有较高的自我管理和任务跟进推动能力。'
      ]
    },
    {
      'title': '平台研发工程师',
      'responsibilities': [
        '1. 参与自动化测试、自动化运维等平台的开发维护工作；',
        '2. 负责公司内已有各类平台的维护、优化、故障解决等。'
      ],
      'requirements': [
        '1. 计算机或其他相关专业本科以上学历；',
        '2. 熟悉至少一种编程语言，熟悉WEB编程；',
        '3. 熟悉Linux操作，能熟练部署和维护linux服务器上的服务;',
        '4. 有解决复杂问题和编写自动脚本和系统开发的能力。'
      ]
    },
  ],
  'product': [
    {
      'title': '剧情策划',
      'responsibilities': [
        '1. 负责游戏世界观、故事架构的完善与优化工作；',
        '2. 参与设定游戏角色、场景，提供角色、场景故事；',
        '3. 对游戏系统、玩法、宣传、动画等提供剧情设定支持和优化方案；',
        '4. 参与游戏体验相关的优化开发；',
        '5. 参与游戏现有系统的优化设计和制作美术优化需求策划案；'
      ],
      'requirements': [
        '1. 本科及以上学历；',
        '2. 擅长创作，文笔优秀，具备以游戏语言表达剧情的意识与能力；',
        '3. 善于沟通，有良好的团队合作精神。'
      ]
    },
    {
      'title': '数值策划',
      'responsibilities': [
        '1. 设计，规划，演算游戏内各项数值；',
        '2. 具有整体规划游戏数值体系和经济系统经验；',
        '3. 团队协作沟通，按项目需求对游戏内数值进行配置和验收；',
        '4. 持续优化游戏性，持续改善游戏体验。'
      ],
      'requirements': [
        '1. 计算机或数学相关专业优先；',
        '2. 具备严谨的逻辑思考能力，对数值平衡有一定心得和研究；',
        '3. 熟练使用Excel，具备良好团队协作能力和沟通能力；',
        '4. 能承受有压力的工作；',
        '5. 深入熟悉二次元文化者优先；',
        '6. 能理解二次元核心圈思想者优先。'
      ]
    },
    {
      'title': '关卡策划',
      'responsibilities': [
        '1. 负责游戏内关卡的玩法及体验设计；',
        '2. 负责游戏内怪物或主角的技能、AI设计及制作；',
        '3. 负责制定关卡的需求文档，包含美术需求和功能逻辑需求；',
        '4. 负责游戏策略性设计。'
      ],
      'requirements': [
        '1. 热爱游戏，对玩法乐趣和效果有自己的看法，并制定改进策略；',
        '2. 有一定的逻辑分析能力，沟通能力，和创意度；',
        '3. 具备良好的沟通表达能力，抗压能力，拥有优秀的团队协作与执行能力；',
        '4. 善于分析移动平台游戏与用户特点。'
      ]
    },
    {
      'title': '系统策划',
      'responsibilities': [
        '1. 负责游戏相关系统规则等设计和跟进；',
        '2. 根据系统架构的要求，完成游戏体验玩法、系统架构等的方案设计、制作、跟进以及测试验证；',
        '3. 配合其他部门进行各系统的执行工作，确保功能实现精度；',
        '4. 验收系统，保证功能实现，提出游戏优化改进方案。'
      ],
      'requirements': [
        '1. 热爱游戏行业，游戏体验丰富敏感；',
        '2. 有游戏行业实习经验优先；',
        '3. 具有丰富的游戏经验，对于网络游戏主要玩法系统有深入的了解和独到的认识，了解各种类型的知名游戏；',
        '4. 吃苦耐劳，责任心强，执行力强.有很优秀的沟通能力。'
      ]
    }
  ],
  'design': [
    {
      'title': 'UI设计师',
      'responsibilities': [
        '1. 完成界面相关标志、图标、图素的设计与绘制；',
        '2. 跟进设计效果最终在产品的实现，保证设计品质与实现品质一致。'
      ],
      'requirements': [
        '1. 具有扎实的美术功底，良好的色彩搭配感及设计造型的能力；',
        '2. 有较强的手绘能力，能独立进行精绘界面中的设计图素与图标；',
        '3. 热爱游戏事业，工作态度积极，具有良好的工作协作能力、团队合作精神，善于沟通。'
      ]
    },
    {
      'title': '场景/角色原画',
      'responsibilities': [
        '1. 负责产品中的场景/角色概念、宣传输出。'
      ],
      'requirements': [
        '1. 美术功底扎实、富有想象力和创造力。对游戏画面表现，技术实现有深入理解；',
        '2. 熟练掌握该岗位所需软件，有较强的学习能力和适应项目风格的能力，主动研究或学习新的技术运用到工作中。'
      ]
    },
    {
      'title': '美宣设计师',
      'responsibilities': [
        '1. 负责公司相关产品的美术视觉设计，主要包括客户端界面，web端界面，推广素材，大型活动推广等视觉相关内容。'
      ],
      'requirements': [
        '1. 熟悉常用的图像处理工具(Photoshop、Dreamweaver、HTML、CSS、JS；等）；',
        '2. 有较强的界面设计表达能力，有良好的创意思维，注重细节。'
      ]
    },
    {
      'title': '3D场景/角色',
      'responsibilities': [
        '1. 负责游戏内场景地图/人物角色的制作，渲染。对所有场景氛围进行统一把控；',
        '2. 对游戏内场景/角色进行最终效果调整，配合制定并制作各类配置系统（例如设施，寻路，碰撞等）。'
      ],
      'requirements': [
        '1. 熟悉MAX、Maya、PS等相关专业软件；',
        '2. 能够完成场景/角色制作和整合，氛围到位，以及有自己特点和创新。'
      ]
    },
    {
      'title': '3D特效',
      'responsibilities': [
        '1. 负责游戏中角色、场景、UI、界面的各种3D特效元素设计和制作；',
        '2. 能对特效动画时间进行合理的掌控，配合角色动画进行特效制作。'
      ],
      'requirements': [
        '1. 有扎实美术功底和良好的特效分析设计能力；',
        '2. 了解动画原理，能准确把握打击感、节奏感等动作制作关键要素；',
        '3. 有出色的学习和沟通能力，有责任心，良好的团队合作精神。'
      ]
    },
    {
      'title': '3D动作设计师',
      'responsibilities': [
        '1. 根据项目需求文档设计相符合要求的动作;',
        '2. 负责相关的角色和怪物模型绑定。'
      ],
      'requirements': [
        '1. 熟悉掌握相关动作软件；',
        '2. 有良好的动画感觉，有较好的动画制作理论知识，对游戏动作制作有一定认识；',
        '3. 良好的沟通能力，有事业心，具备团队合作精神。'
      ]
    }
  ]
}

const BottomCooperativeMedia = [
  {
    'src': cooperative1,
    'href': 'http://www.gametanzi.com/'
  },
  {
    'src': cooperative2,
    'href': 'http://www.benshouji.com/'
  },
  {
    'src': cooperative3,
    'href': 'http://www.17sysj.com/'
  },
  {
    'src': cooperative4,
    'href': 'http://www.tyouwang.com/'
  },
  {
    'src': cooperative5,
    'href': 'http://shouji.7k7k.com/'
  },
  {
    'src': cooperative6,
    'href': 'http://www.fahao.cn/'
  },
  {
    'src': cooperative7,
    'href': 'http://www.kuai8.com/'
  },
  {
    'src': cooperative8,
    'href': 'http://www.139y.com/'
  },
  {
    'src': cooperative9,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': cooperative1,
    'href': 'http://www.gametanzi.com/'
  },
  {
    'src': cooperative2,
    'href': 'http://www.benshouji.com/'
  },
  {
    'src': cooperative3,
    'href': 'http://www.17sysj.com/'
  },
  {
    'src': cooperative4,
    'href': 'http://www.tyouwang.com/'
  },
  {
    'src': cooperative5,
    'href': 'http://shouji.7k7k.com/'
  },
  {
    'src': cooperative6,
    'href': 'http://www.fahao.cn/'
  },
  {
    'src': cooperative7,
    'href': 'http://www.kuai8.com/'
  },
  {
    'src': cooperative8,
    'href': 'http://www.139y.com/'
  },
  {
    'src': cooperative9,
    'href': 'https://www.zhuayoukong.com/'
  },
]

const AdList = [
  {
    'src': ad1,
    'href': 'http://www.gametanzi.com/'
  },
  {
    'src': ad2,
    'href': 'http://www.benshouji.com/'
  },
  {
    'src': ad3,
    'href': 'http://www.17sysj.com/'
  },
  {
    'src': ad4,
    'href': 'http://www.tyouwang.com/'
  },
  {
    'src': ad5,
    'href': 'http://shouji.7k7k.com/'
  },
  {
    'src': ad6,
    'href': 'http://www.fahao.cn/'
  },
  {
    'src': ad7,
    'href': 'http://www.kuai8.com/'
  },
  {
    'src': ad8,
    'href': 'http://www.139y.com/'
  },
  {
    'src': ad9,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad10,
    'href': 'http://www.gametanzi.com/'
  },
  {
    'src': ad11,
    'href': 'http://www.benshouji.com/'
  },
  {
    'src': ad12,
    'href': 'http://www.17sysj.com/'
  },
  {
    'src': ad13,
    'href': 'http://www.tyouwang.com/'
  },
  {
    'src': ad14,
    'href': 'http://shouji.7k7k.com/'
  },
  {
    'src': ad15,
    'href': 'http://www.fahao.cn/'
  },
  {
    'src': ad16,
    'href': 'http://www.kuai8.com/'
  },
  {
    'src': ad17,
    'href': 'http://www.139y.com/'
  },
  {
    'src': ad18,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad19,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad20,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad21,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad22,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad23,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad24,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad25,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad26,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad27,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad28,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad29,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad30,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad31,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad32,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad33,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad34,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad35,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad36,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad37,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad38,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad39,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad40,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad41,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad42,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad43,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad44,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad45,
    'href': 'https://www.zhuayoukong.com/'
  },
  {
    'src': ad46,
    'href': 'https://www.zhuayoukong.com/'
  }
]

const OpenApiDoMain = 'https://cms.gg.com/openApi'

export { gameList, JDList, BottomCooperativeMedia, AdList, OpenApiDoMain }


// WEBPACK FOOTER //
// ./src/constants.tsx